
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    // 入力時の自動Ajax処理を無効化（Applyボタン押下時のみフィルタリング）
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    
    // SearchページとCollectionページの両方に対応
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collectionElement = productGridContainer.querySelector('.collection');
      if (collectionElement) {
        collectionElement.classList.add('loading');
      } else {
        // Searchページの場合、直接ProductGridContainerにloadingクラスを追加
        productGridContainer.classList.add('loading');
      }
    }
    
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      console.log('Ajax URL being fetched:', url);
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
    // 表示件数変更時のデバッグログ
    const urlParams = new URLSearchParams(searchParams);
    const limitParam = urlParams.get('limit');
    if (limitParam) {
      console.log('Limit parameter detected in renderPage:', limitParam);
    }
  }

  static renderSectionFromFetch(url, event) {
    console.log('Fetching section from URL:', url);
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        console.log('Response received, HTML length:', html.length);
        
        // レスポンスHTMLにlimitパラメータが含まれているかチェック
        if (html.includes('limit=')) {
          console.log('Limit parameter found in response HTML');
        } else {
          console.log('Limit parameter NOT found in response HTML');
        }
        
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        
        // カスタムイベントを発火（パンくず更新用）
        document.dispatchEvent(new CustomEvent('facet:updated', {
          detail: { url: url, html: html }
        }));
      })
      .catch((error) => {
        console.error('Error fetching section:', error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    
    // カスタムイベントを発火（パンくず更新用）
    document.dispatchEvent(new CustomEvent('facet:updated', {
      detail: { url: filterDataUrl.url, html: html }
    }));
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      productGridContainer.innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('ProductGridContainer').innerHTML;

      // 読み込み状態を解除
      productGridContainer.classList.remove('loading');
      
      // Collectionページの場合のみ、.collection要素の読み込み状態も解除
      const collectionElement = productGridContainer.querySelector('.collection');
      if (collectionElement) {
        collectionElement.classList.remove('loading');
      }

      productGridContainer
        .querySelectorAll('.scroll-trigger')
        .forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
        });
      
      // DOM更新後にカテゴリー連動機能を再設定
      setTimeout(() => {
        setupCategoryEventListeners();
        // フィルター状態を復元
        FacetFiltersForm.restoreFilterStateAfterAjax();
        // ソートとアイテム数表示の同期を再初期化
        syncFilterLabels();
        // Globo Color Swatch 等のスウォッチアプリ用: 商品グリッド差し替え後に再初期化を試行
        if (typeof window.reinitGloboSwatches === 'function') {
          window.reinitGloboSwatches();
        }
        document.dispatchEvent(new CustomEvent('globo:product-grid-updated', {
          detail: { container: productGridContainer }
        }));
      }, 50);
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    
    // フィルターセクションのトグル処理を再初期化
    FacetFiltersForm.reinitializeFilterToggles();
    
    // Ajax処理後にフィルター状態を復元
    FacetFiltersForm.restoreFilterStateAfterAjax();

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static reinitializeFilterToggles() {
    console.log('reinitializeFilterToggles called');
    
    // グローバルフラグをリセット（重複実行防止フラグをクリア）
    if (window.mobileFacetsInitialized) {
      window.mobileFacetsInitialized = false;
    }
    
    // フィルター要素の初期化フラグをリセット
    const filterContainers = document.querySelectorAll('.filter-container');
    filterContainers.forEach(container => {
      container.dataset.mobileFacetsInitialized = 'false';
      console.log('Reset flag for:', container.id, 'to false');
    });
    
    // jQuery処理を再初期化
    if (typeof jQuery !== 'undefined') {
      console.log('jQuery available, reinitializing jQuery toggles');
      jQuery(function ($) {
        // FAQアイテムを除外してフィルター要素のみに適用
        $('.js-filter').not('.faq-item').each(function () {
          var $wrap    = $(this);
          var $summary = $wrap.find('.mobile-facets__summary').first();
          var $panel   = $summary.nextAll('div').first();

          if (!$summary.length || !$panel.length) return;

          if ($summary.hasClass('is-open')) {
            $panel.show();
            $summary.attr('aria-expanded', 'true');
          } else {
            $panel.hide();
            $summary.attr('aria-expanded', 'false');
          }

          $summary.attr({ role: 'button', tabindex: 0 });

          function toggle() {
            var willOpen = !$summary.hasClass('is-open');
            $summary.toggleClass('is-open', willOpen)
                    .attr('aria-expanded', willOpen ? 'true' : 'false');
            $panel.stop(true, true);
          }

          $summary.off('.filterToggle')
            .on('click.filterToggle', function (e) {
              e.preventDefault();
              e.stopPropagation();
              toggle();
            })
            .on('keydown.filterToggle', function (e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggle();
              }
            });
        });
      });
    } else {
      console.log('jQuery not available, using vanilla JavaScript for toggles');
      // jQueryが利用できない場合は、vanilla JavaScriptでトグル処理を実装
      const filterElements = document.querySelectorAll('.js-filter:not(.faq-item)');
      filterElements.forEach(element => {
        const summary = element.querySelector('.mobile-facets__summary');
        const panel = summary ? summary.nextElementSibling : null;
        
        if (!summary || !panel) return;
        
        // 既存のイベントリスナーを削除
        summary.removeEventListener('click', handleToggleClick);
        summary.removeEventListener('keydown', handleToggleKeydown);
        
        // 新しいイベントリスナーを追加
        summary.addEventListener('click', handleToggleClick);
        summary.addEventListener('keydown', handleToggleKeydown);
        
        function handleToggleClick(e) {
          e.preventDefault();
          e.stopPropagation();
          toggle();
        }
        
        function handleToggleKeydown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        }
        
        function toggle() {
          const isOpen = summary.classList.contains('is-open');
          if (isOpen) {
            summary.classList.remove('is-open');
            panel.style.display = 'none';
            summary.setAttribute('aria-expanded', 'false');
          } else {
            summary.classList.add('is-open');
            panel.style.display = 'block';
            summary.setAttribute('aria-expanded', 'true');
          }
        }
      });
    }
    
    // 汎用アコーディオン処理を再初期化
    if (typeof initializeAccordion === 'function') {
      console.log('initializeAccordion available, reinitializing accordion');
      initializeAccordion({
        containerSelector: '.mobile-facets__main',
        itemSelector: '.filter-container',
        triggerSelector: '.mobile-facets__summary-header',
        contentSelector: '.mobile-facets__summary-inner',
        openClass: 'is-open',
        globalFlag: 'mobileFacetsInitialized',
        itemDataFlag: 'mobileFacetsInitialized',
        animationDuration: '0.3s'
      });
    }
  }

  // フィルター状態を保存する関数
  static saveFilterState() {
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (!mobileForm) return;

    const filterState = {
      // Category1（空の値は保存しない）
      category1: document.getElementById('category-1')?.value || '',
      // Category2（空の値は保存しない）
      category2: document.getElementById('category-2')?.value || '',
      // Character checkboxes
      characters: Array.from(document.querySelectorAll('input[name="filter.p.m.scapp.characterCode"]:checked')).map(cb => cb.value),
      // Price
      minPrice: document.querySelector('input[name="filter.v.price.gte"]')?.value || '',
      maxPrice: document.querySelector('input[name="filter.v.price.lte"]')?.value || '',
      // Price Type radio
      priceType: document.querySelector('input[name="filter.p.m.scapp.salesType"]:checked')?.value || '',
      // Availability radio
      availability: document.querySelector('input[name="filter.v.availability"]:checked')?.value || '',
      // Gift Wrapping radio
      giftWrapping: document.querySelector('input[name="filter.p.m.scapp.wrappingNGFlag"]:checked')?.value || '',
      // Sort By
      sortBy: document.getElementById('SortBy-mobile')?.value || '',
      // Items per Page（URLパラメータを優先）
      itemsPerPage: document.getElementById('product-limit-mobile')?.value || new URLSearchParams(window.location.search).get('limit') || ''
    };

    // セッションストレージに保存
    sessionStorage.setItem('filterState', JSON.stringify(filterState));
    console.log('Filter state saved:', filterState);
  }

  // Ajax処理後にフィルター状態を復元する関数
  static restoreFilterStateAfterAjax() {
    // 一時保存されたカテゴリー状態を優先チェック
    const tempCategoryState = sessionStorage.getItem('tempCategoryState');
    if (tempCategoryState) {
      console.log('Temporary category state found, skipping Ajax restoration');
      return; // 一時保存された状態がある場合は復元をスキップ
    }

    const savedState = sessionStorage.getItem('filterState');
    if (!savedState) return;

    // 重複実行を防ぐフラグ
    if (window.filterStateRestoring) return;
    window.filterStateRestoring = true;

    // DOMの更新を待つために少し遅延
    setTimeout(() => {
      try {
        const filterState = JSON.parse(savedState);
        console.log('Restoring filter state after Ajax:', filterState);

        // Category1とCategory2の復元（連動機能を考慮）
        const category1Select = document.getElementById('category-1');
        const category2Select = document.getElementById('category-2');
        
        console.log('Category elements found:', {
          category1: !!category1Select,
          category2: !!category2Select,
          category1Value: filterState.category1,
          category2Value: filterState.category2
        });
        
        if (category1Select && filterState.category1) {
          console.log('Restoring Category1:', filterState.category1);
          category1Select.value = filterState.category1;
          // カテゴリー連動機能を再実行
          category1Select.dispatchEvent(new Event('change'));
          
          // Category2の復元は少し遅延させて、Category1のchangeイベント処理後に実行
          setTimeout(() => {
            const category2SelectAfter = document.getElementById('category-2');
            if (category2SelectAfter && filterState.category2) {
              // Category2の選択肢が利用可能かチェック
              const availableOptions = Array.from(category2SelectAfter.options);
              const targetOption = availableOptions.find(option => option.value === filterState.category2);
              if (targetOption) {
                category2SelectAfter.value = filterState.category2;
                console.log('Category2 restored:', filterState.category2);
                // 復元後にchangeイベントを発火
                category2SelectAfter.dispatchEvent(new Event('change'));
              } else {
                console.log('Category2 option not available:', filterState.category2, 'Available options:', availableOptions.map(o => o.value));
              }
            }
          }, 200);
        } else if (category2Select && filterState.category2) {
          // Category1がない場合でもCategory2を復元
          category2Select.value = filterState.category2;
          category2Select.dispatchEvent(new Event('change'));
        }

        // Character checkboxesを復元
        if (filterState.characters && filterState.characters.length > 0) {
          filterState.characters.forEach(characterValue => {
            const checkbox = document.querySelector(`input[name="filter.p.m.scapp.characterCode"][value="${characterValue}"]`);
            if (checkbox) {
              checkbox.checked = true;
            }
          });
        }

        // Priceを復元
        const minPriceInput = document.querySelector('input[name="filter.v.price.gte"]');
        if (minPriceInput && filterState.minPrice) {
          minPriceInput.value = filterState.minPrice;
        }
        const maxPriceInput = document.querySelector('input[name="filter.v.price.lte"]');
        if (maxPriceInput && filterState.maxPrice) {
          maxPriceInput.value = filterState.maxPrice;
        }

        // Price Type radioを復元
        if (filterState.priceType) {
          const priceTypeRadio = document.querySelector(`input[name="filter.p.m.scapp.salesType"][value="${filterState.priceType}"]`);
          if (priceTypeRadio) {
            priceTypeRadio.checked = true;
          }
        }

        // Availability radioを復元
        if (filterState.availability) {
          const availabilityRadio = document.querySelector(`input[name="filter.v.availability"][value="${filterState.availability}"]`);
          if (availabilityRadio) {
            availabilityRadio.checked = true;
          }
        }

        // Gift Wrapping radioを復元
        if (filterState.giftWrapping) {
          const giftWrappingRadio = document.querySelector(`input[name="filter.p.m.scapp.wrappingNGFlag"][value="${filterState.giftWrapping}"]`);
          if (giftWrappingRadio) {
            giftWrappingRadio.checked = true;
          }
        }

        // Sort Byを復元
        if (filterState.sortBy) {
          const sortSelect = document.getElementById('SortBy-mobile');
          if (sortSelect) {
            sortSelect.value = filterState.sortBy;
            console.log('Sort By restored:', filterState.sortBy);
          }
        }

        // Items per Pageを復元（URLパラメータを優先）
        // FacetFiltersForm.searchParamsPrevを使用（Ajax通信で使用された最新のパラメータ）
        let urlLimit = null;
        if (FacetFiltersForm.searchParamsPrev) {
          const urlParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev);
          urlLimit = urlParams.get('limit');
          console.log('Items per Page from searchParamsPrev:', urlLimit);
        }
        
        // searchParamsPrevから取得できなかった場合、window.location.searchから取得
        if (!urlLimit) {
          const urlParams = new URLSearchParams(window.location.search);
          urlLimit = urlParams.get('limit');
          console.log('Items per Page from window.location.search:', urlLimit);
        }
        
        if (urlLimit) {
          // URLパラメータがある場合はそれを優先
          const limitSelect = document.getElementById('product-limit-mobile');
          if (limitSelect) {
            limitSelect.value = urlLimit;
            console.log('Items per Page restored from URL:', urlLimit);
            console.log('Limit select element value after restore:', limitSelect.value);
          } else {
            console.log('Limit select element not found');
          }
        } else if (filterState.itemsPerPage) {
          // URLパラメータがない場合のみセッションストレージから復元
          const limitSelect = document.getElementById('product-limit-mobile');
          if (limitSelect) {
            limitSelect.value = filterState.itemsPerPage;
            console.log('Items per Page restored from session:', filterState.itemsPerPage);
            console.log('Limit select element value after restore:', limitSelect.value);
          } else {
            console.log('Limit select element not found');
          }
        }

        // 復元後にラベル表示を同期
        setTimeout(() => {
          updateSortLabel();
          updateLimitLabel();
          updatePriceTypeLabel();
          updateAvailabilityLabel();
          updateGiftWrappingLabel();
        }, 100);

      } catch (error) {
        console.error('Error restoring filter state:', error);
      } finally {
        // フラグをリセット
        window.filterStateRestoring = false;
      }
    }, 300); // DOMの更新を待つための遅延
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const newUrl = `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`;
    // 現在のURLと異なる場合のみpushStateを実行（重複を防ぐ）
    // URLパラメータの順序を無視して比較
    if (!FacetFiltersForm.isSameUrl(window.location.href, newUrl)) {
      history.pushState({ searchParams }, '', newUrl);
      console.log('updateURLHash: URL updated to:', newUrl);
    } else {
      console.log('updateURLHash: URL unchanged, skipping pushState:', newUrl);
    }
  }
  
  // URLパラメータの順序を無視して比較する関数
  static isSameUrl(url1, url2) {
    try {
      const u1 = new URL(url1, window.location.origin);
      const u2 = new URL(url2, window.location.origin);
      
      // パスが異なる場合は異なるURL
      if (u1.pathname !== u2.pathname) {
        return false;
      }
      
      // パラメータをソートして比較
      const params1 = Array.from(u1.searchParams.entries()).sort();
      const params2 = Array.from(u2.searchParams.entries()).sort();
      
      if (params1.length !== params2.length) {
        return false;
      }
      
      return params1.every(([key, value], index) => {
        return key === params2[index][0] && value === params2[index][1];
      });
    } catch (e) {
      // URL解析に失敗した場合は文字列比較
      return url1 === url2;
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  createSearchParamsWithMultipleValues(form) {
    const formData = new FormData(form);
    const formDataMap = new Map();
    
    // 同じキーの値を配列として収集
    formData.forEach((value, key) => {
      if (value && value.trim() !== '') {
        if (!formDataMap.has(key)) {
          formDataMap.set(key, []);
        }
        formDataMap.get(key).push(value);
      }
    });
    
    // URLSearchParamsを作成
    const searchParams = new URLSearchParams();
    formDataMap.forEach((values, key) => {
      // カテゴリーパラメータは除外（後で優先ロジックで追加）
      if (key === 'filter.p.m.scapp.categoryCodeList' || key === 'filter.p.m.scapp.categoryNameList') {
        return;
      }
      
      if (values.length === 1) {
        searchParams.set(key, values[0]);
      } else {
        // 複数値の場合は、既存のパラメータを削除してから追加
        searchParams.delete(key);
        values.forEach(value => {
          searchParams.append(key, value);
        });
      }
    });
    
    // Category2を優先するロジック（重複パラメータを避ける）
    const category1Value = document.getElementById('category-1')?.value;
    const category2Value = document.getElementById('category-2')?.value;
    
    // Category2が選択されている場合はCategory2のみを使用、そうでなければCategory1を使用
    console.log('Category values in createSearchParamsWithMultipleValues:', {
      category1: category1Value,
      category2: category2Value
    });
    
    if (category2Value && category2Value !== '' && category2Value !== 'All') {
      // メタフィールドフィルタリング用のパラメータ（等号形式）
      searchParams.append('filter.p.m.scapp.categoryCodeList', category2Value);
      console.log('Using Category2 only (priority) with equals format:', category2Value);
    } else if (category1Value && category1Value !== '' && category1Value !== 'All') {
      // メタフィールドフィルタリング用のパラメータ（等号形式）
      searchParams.append('filter.p.m.scapp.categoryCodeList', category1Value);
      console.log('Using Category1 only (fallback) with equals format:', category1Value);
    }
    
    console.log('Category priority logic applied:', {
      category1: category1Value,
      category2: category2Value,
      selected: category2Value && category2Value !== '' && category2Value !== 'All' ? 'Category2' : 'Category1'
    });
    
    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    // URLを更新してからAjax処理を実行
    const url = new URL(window.location);
    
    // キーワード検索の処理
    const keywordInput = document.getElementById('Filter-Keyword-Search');
    let keywordValue = keywordInput ? keywordInput.value.trim() : '';
    
    // キーワード検索欄が空の場合、URLのqパラメータを取得
    if (!keywordValue) {
      const urlQParam = url.searchParams.get('q');
      if (urlQParam && urlQParam.trim() !== '') {
        keywordValue = urlQParam.trim();
        console.log('PC用: キーワード検索欄が空のため、URLのqパラメータを使用:', keywordValue);
      }
    }
    
    // キーワード検索がある場合はSearchページへ遷移
    if (keywordValue) {
      console.log('PC用: キーワード検索があるため、Searchページへ遷移します:', keywordValue);
      
      // SearchページのURLを構築
      const searchUrl = new URL('/search', window.location.origin);
      searchUrl.searchParams.set('q', keywordValue);
      
      // 他のフィルター設定を保持
      const urlParams = new URLSearchParams(searchParams);
      urlParams.forEach((value, key) => {
        if (key !== 'q') { // qパラメータは除外
          searchUrl.searchParams.set(key, value);
        }
      });
      
      // Searchページへ遷移
      console.log('PC用: Redirecting to search page with filters:', searchUrl.toString());
      window.location.href = searchUrl.toString();
      return;
    }
    
    // 既存のカテゴリーパラメータを削除
    const categoryKeys = Array.from(url.searchParams.keys()).filter(key => 
      key.startsWith('filter.p.m.scapp.categoryCodeList') || 
      key.startsWith('filter.p.m.scapp.categoryNameList')
    );
    categoryKeys.forEach(key => url.searchParams.delete(key));
    
    // 新しいパラメータを追加
    urlParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });
    
    // 現在のURLと異なる場合のみpushStateを実行（重複を防ぐ）
    // URLパラメータの順序を無視して比較
    const newUrl = url.toString();
    if (!FacetFiltersForm.isSameUrl(window.location.href, newUrl)) {
      window.history.pushState({ searchParams }, '', newUrl);
      console.log('onSubmitForm: URL updated to:', newUrl);
    } else {
      console.log('onSubmitForm: URL unchanged, skipping pushState:', newUrl);
    }
    
    // Ajax処理でフィルタリングを実行
    // renderPage()内のupdateURLHash()をスキップして、重複した履歴エントリを防ぐ
    FacetFiltersForm.renderPage(searchParams, event, false);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    // Applyボタンが押された時のみフィルタリングを実行
    const isApplyButton = event.target.classList.contains('filter-submit-button') || 
                         event.target.classList.contains('apply-filters-button') || 
                         event.target.classList.contains('mobile-facets__button') ||
                         event.target.textContent.trim().toLowerCase().includes('apply');
    
    if (!isApplyButton) {
      console.log('Auto-filtering disabled, only Apply button triggers filtering');
      return;
    }
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      // チェックボックスの自動フィルタリングも無効化
      console.log('Checkbox auto-filtering disabled, only Apply button triggers filtering');
      return;
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        forms.push(this.createSearchParamsWithMultipleValues(form));
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    // 最小価格が空の場合は、最大価格の最小値を設定しない（制限を設けない）
    if (minInput.value === '') maxInput.removeAttribute('data-min');
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const minAttr = input.getAttribute('data-min');
    const maxAttr = input.getAttribute('data-max');
    
    // data-min属性が存在する場合のみ最小値チェック
    if (minAttr !== null) {
      const min = Number(minAttr);
      if (value < min) input.value = min;
    }
    
    // data-max属性が存在する場合のみ最大値チェック
    if (maxAttr !== null) {
      const max = Number(maxAttr);
      if (value > max) input.value = max;
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    
    // Remove Allリンクの場合はremoveAllFilters()を呼び出す
    const link = this.querySelector('a');
    if (link && (
      link.classList.contains('active-facets__button-remove') || 
      link.classList.contains('mobile-facets__clear') ||
      link.href.includes('results_url') ||
      link.textContent.trim() === 'Clear all' ||
      link.textContent.trim() === 'Remove all' ||
      link.textContent.trim().toLowerCase().includes('clear') ||
      link.textContent.trim().toLowerCase().includes('remove')
    )) {
      console.log('Remove All clicked (dynamic), calling removeAllFilters()');
      removeAllFilters();
      return;
    }
    
    // 個別フィルターボタンのクリックは無効化（何もしない）
    console.log('Individual filter button clicked - disabled');
    return;
  }
}

customElements.define('facet-remove', FacetRemove);

// URLパラメータからフィルター状態を復元する関数
function restoreFilterState() {
  const urlParams = new URLSearchParams(window.location.search);
  
  // フィルターフォームの状態を復元
  const mobileForm = document.getElementById('FacetFiltersFormMobile');
  if (mobileForm) {
    restoreFormState(mobileForm, urlParams, true); // 価格フィールドを除外
    restorePriceFields(mobileForm, urlParams); // 価格フィールドを特別に復元
  }
  
  // セッションストレージからフィルター状態を復元（URLパラメータがない場合）
  const savedState = sessionStorage.getItem('filterState');
  if (savedState && !hasFilterParams(urlParams)) {
    try {
      const filterState = JSON.parse(savedState);
      console.log('Restoring filter state from sessionStorage:', filterState);
      restoreFilterStateFromStorage(filterState);
    } catch (error) {
      console.error('Error restoring filter state from sessionStorage:', error);
    }
  }
}

// ページ離脱時にフィルター状態をクリアする関数
function clearFilterStateOnPageLeave() {
  console.log('Clearing filter state on page leave');
  
  // セッションストレージからフィルター状態を削除
  sessionStorage.removeItem('filterState');
  sessionStorage.removeItem('tempCategoryState');
  
  // カート属性もデフォルトに戻す
  // fetch APIを使用（jQueryの依存を避けるため）
  // ShopifyのカートAPI: /cart/update.js にPOSTリクエストを送信
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        pagination: "60"
      }
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    console.log('Cart attributes reset to default on page leave');
  })
  .catch(error => {
    console.error('Error resetting cart attributes:', error);
  });
}

// ページ復帰時にデフォルト状態に戻す関数
function resetToDefaultOnPageReturn() {
  console.log('Resetting to default state on page return');
  
  // デフォルトのフィルター状態を設定
  const defaultFilterState = {
    sortBy: 'created-descending',
    itemsPerPage: '60',
    category1: '',
    category2: ''
  };
  
  // セッションストレージにデフォルト状態を保存
  sessionStorage.setItem('filterState', JSON.stringify(defaultFilterState));
  
  // カテゴリー要素をデフォルト値に設定
  const category1Select = document.getElementById('category-1');
  const category2Select = document.getElementById('category-2');
  
  if (category1Select) {
    category1Select.value = '';
  }
  
  if (category2Select) {
    category2Select.value = '';
  }
  
  // フォーム要素をデフォルト値に設定
  const sortSelect = document.getElementById('SortBy-mobile');
  const limitSelect = document.getElementById('product-limit-mobile');
  
  if (sortSelect) {
    sortSelect.value = 'created-descending';
  }
  
  if (limitSelect) {
    limitSelect.value = '60';
  }
  
  // ラベル表示を更新
  updateSortLabel();
  updateLimitLabel();
}

// ページ離脱と復帰のハンドラーを設定
function setupPageLeaveAndReturnHandlers() {
  // ページがCollectionページかどうかを判定
  const isCollectionPage = window.location.pathname.includes('/collections') || 
                          window.location.pathname.includes('/search');
  
  if (!isCollectionPage) {
    return; // Collectionページでない場合は何もしない
  }
  
  // ページ離脱時の処理
  let isLeavingPage = false;
  
  // beforeunloadイベント（ページを離れる直前）
  window.addEventListener('beforeunload', function() {
    if (!isLeavingPage) {
      isLeavingPage = true;
      clearFilterStateOnPageLeave();
    }
  });
  
  // visibilitychangeイベント（タブが非表示になった時）
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      // ページが非表示になった時（他のタブに移動、ブラウザを最小化など）
      clearFilterStateOnPageLeave();
    } else {
      // ページが再表示された時
      resetToDefaultOnPageReturn();
    }
  });
  
  // ページフォーカスイベント（ページに戻ってきた時）
  window.addEventListener('focus', function() {
    // 少し遅延させてから実行（他の処理が完了してから）
    setTimeout(() => {
      resetToDefaultOnPageReturn();
    }, 100);
  });
  
  // リンククリック時の離脱検知
  document.addEventListener('click', function(event) {
    const link = event.target.closest('a');
    if (link && link.href) {
      const linkUrl = new URL(link.href, window.location.origin);
      const currentUrl = new URL(window.location.href);
      
      // 異なるページへのリンクの場合
      if (linkUrl.pathname !== currentUrl.pathname) {
        clearFilterStateOnPageLeave();
      }
    }
  });
  
  // ページ離脱フラグをリセット（ページロード時）
  isLeavingPage = false;
}

// URLパラメータにフィルター関連のパラメータがあるかチェック
function hasFilterParams(urlParams) {
  const filterKeys = Array.from(urlParams.keys()).filter(key => 
    key.startsWith('filter.') || 
    key.startsWith('variant_option') || 
    key.startsWith('options[')
  );
  return filterKeys.length > 0;
}

// セッションストレージからフィルター状態を復元
function restoreFilterStateFromStorage(filterState) {
  // Category1とCategory2の復元（連動機能を考慮）
  const category1Select = document.getElementById('category-1');
  const category2Select = document.getElementById('category-2');
  
  // Category2を優先するロジック（空の値は復元しない）
  if (category2Select && filterState.category2 && filterState.category2 !== '' && filterState.category2 !== 'All') {
    // Category2が選択されている場合はCategory2を優先
    console.log('Restoring Category2 from storage (priority):', filterState.category2);
    category2Select.value = filterState.category2;
    
    // Category1も復元（親カテゴリーとして、空でない場合のみ）
    if (category1Select && filterState.category1 && filterState.category1 !== '') {
      category1Select.value = filterState.category1;
      console.log('Restoring Category1 from storage (parent):', filterState.category1);
    }
  } else if (category1Select && filterState.category1 && filterState.category1 !== '' && filterState.category1 !== 'All') {
    // Category2が選択されていない場合はCategory1を使用（空でない場合のみ）
    console.log('Restoring Category1 from storage (fallback):', filterState.category1);
    category1Select.value = filterState.category1;
    // カテゴリー連動機能を再実行
    category1Select.dispatchEvent(new Event('change'));
  }

  // Character checkboxesを復元
  if (filterState.characters && filterState.characters.length > 0) {
    filterState.characters.forEach(characterValue => {
      const checkbox = document.querySelector(`input[name="filter.p.m.scapp.characterCode"][value="${characterValue}"]`);
      if (checkbox) {
        checkbox.checked = true;
      }
    });
  }

  // Priceを復元
  const minPriceInput = document.querySelector('input[name="filter.v.price.gte"]');
  if (minPriceInput && filterState.minPrice) {
    minPriceInput.value = filterState.minPrice;
  }
  const maxPriceInput = document.querySelector('input[name="filter.v.price.lte"]');
  if (maxPriceInput && filterState.maxPrice) {
    maxPriceInput.value = filterState.maxPrice;
  }

  // Price Type radioを復元
  if (filterState.priceType) {
    const priceTypeRadio = document.querySelector(`input[name="filter.p.m.scapp.salesType"][value="${filterState.priceType}"]`);
    if (priceTypeRadio) {
      priceTypeRadio.checked = true;
    }
  }

  // Availability radioを復元
  if (filterState.availability) {
    const availabilityRadio = document.querySelector(`input[name="filter.v.availability"][value="${filterState.availability}"]`);
    if (availabilityRadio) {
      availabilityRadio.checked = true;
    }
  }

  // Gift Wrapping radioを復元
  if (filterState.giftWrapping) {
    const giftWrappingRadio = document.querySelector(`input[name="filter.p.m.scapp.wrappingNGFlag"][value="${filterState.giftWrapping}"]`);
    if (giftWrappingRadio) {
      giftWrappingRadio.checked = true;
    }
  }

  // Sort Byを復元
  if (filterState.sortBy) {
    const sortSelect = document.getElementById('SortBy-mobile');
    if (sortSelect) {
      sortSelect.value = filterState.sortBy;
      console.log('Sort By restored from storage:', filterState.sortBy);
    }
  }

  // Items per Pageを復元
  if (filterState.itemsPerPage) {
    const limitSelect = document.getElementById('product-limit-mobile');
    if (limitSelect) {
      limitSelect.value = filterState.itemsPerPage;
      console.log('Items per Page restored from storage:', filterState.itemsPerPage);
    }
  }

  // 復元後にラベル表示を同期
  setTimeout(() => {
    updateSortLabel();
    updateLimitLabel();
    updatePriceTypeLabel();
    updateAvailabilityLabel();
    updateGiftWrappingLabel();
  }, 100);
}

// フォームの状態を復元する関数
function restoreFormState(form, urlParams, excludePriceFields = false) {
  // チェックボックスの状態を復元
  const checkboxes = form.querySelectorAll('input[type="checkbox"]');
  checkboxes.forEach(checkbox => {
    const paramName = checkbox.name;
    if (paramName && urlParams.has(paramName)) {
      const paramValues = urlParams.getAll(paramName); // 複数の値を取得
      if (paramValues.includes(checkbox.value)) {
        checkbox.checked = true;
      }
    }
  });
  
  // ラジオボタンの状態を復元
  const radioButtons = form.querySelectorAll('input[type="radio"]');
  radioButtons.forEach(radio => {
    const paramName = radio.name;
    if (paramName && urlParams.has(paramName)) {
      const paramValue = urlParams.get(paramName);
      if (paramValue === radio.value) {
        radio.checked = true;
      }
    }
  });
  
  // セレクトボックスの状態を復元（Category1とCategory2の連動処理を考慮）
  const selects = form.querySelectorAll('select');
  const category1Select = document.getElementById('category-1');
  const category2Select = document.getElementById('category-2');
  
  // Category1とCategory2の特別処理（Category2を優先）
  if (category1Select && category2Select) {
    const allCategoryParams = urlParams.getAll('filter.p.m.scapp.categoryCodeList');
    
    console.log('URL params for categories:', {
      allCategoryParams: allCategoryParams,
      length: allCategoryParams.length
    });
    
    // Category1を復元（最初の値）
    if (allCategoryParams.length > 0) {
      const categoryValue = allCategoryParams[0];
      console.log('Restoring category from URL:', categoryValue);
      
      // まずCategory1に値を設定
      category1Select.value = categoryValue;
      
      // カテゴリー連動機能を再実行（少し遅延させて、他の初期化処理と競合しないようにする）
      setTimeout(() => {
        category1Select.dispatchEvent(new Event('change'));
        
        // Category2の選択肢が利用可能かチェック
        setTimeout(() => {
          const availableOptions = Array.from(category2Select.options);
          const targetOption = availableOptions.find(option => option.value === categoryValue);
          
          if (targetOption) {
            // Category2に同じ値が利用可能な場合はCategory2を選択（優先）
            category2Select.value = categoryValue;
            console.log('Category2 restored from URL (priority):', categoryValue);
          } else {
            // Category2に値が利用できない場合はCategory1のみを使用
            console.log('Category2 option not available, using Category1 only:', categoryValue);
          }
        }, 300);
      }, 100);
    }
  } else {
    // 通常のセレクトボックスの復元
    selects.forEach(select => {
      const paramName = select.name;
      if (paramName && urlParams.has(paramName)) {
        const paramValue = urlParams.get(paramName);
        select.value = paramValue;
      }
    });
  }
  
  // キーワード検索フィールドをURLパラメータから復元
  const keywordInputs = form.querySelectorAll('input[type="search"], input[name="q"]');
  keywordInputs.forEach(input => {
    if (urlParams.has('q')) {
      const qValue = urlParams.get('q');
      input.value = qValue;
      console.log('Keyword search field restored from URL:', qValue);
    } else {
      input.value = '';
    }
  });
  
  // テキスト入力の状態を復元（価格フィールドは完全に除外）
  if (!excludePriceFields) {
    const textInputs = form.querySelectorAll('input[type="text"], input[type="number"]');
    textInputs.forEach(input => {
      const paramName = input.name;
      if (paramName && urlParams.has(paramName)) {
        const paramValue = urlParams.get(paramName);
        input.value = paramValue;
      }
    });
  }
  
  // Sort Byの状態を復元
  const sortSelect = form.querySelector('select[name="sort_by"]');
  if (sortSelect && urlParams.has('sort_by')) {
    const sortValue = urlParams.get('sort_by');
    sortSelect.value = sortValue;
    console.log('Sort By restored from URL:', sortValue);
  }
  
  // Items per Pageの状態を復元
  // まずIDで直接探す（フォーム内にない場合もあるため）
  let limitSelect = document.getElementById('product-limit-mobile');
  if (!limitSelect) {
    limitSelect = document.getElementById('product-limit');
  }
  if (!limitSelect) {
    limitSelect = form.querySelector('select[name="limit"]');
  }
  if (limitSelect && urlParams.has('limit')) {
    const limitValue = urlParams.get('limit');
    limitSelect.value = limitValue;
    console.log('Items per Page restored from URL:', limitValue, 'element:', limitSelect.id || limitSelect.name);
  }

  // 復元後にラベル表示を同期
  setTimeout(() => {
    updateSortLabel();
    updateLimitLabel();
    updatePriceTypeLabel();
    updateAvailabilityLabel();
    updateGiftWrappingLabel();
  }, 100);
}

// 価格フィールドの状態を復元する関数
function restorePriceFields(form, urlParams) {
  // 最小価格フィールドの復元
  const minPriceInput = form.querySelector('input[name="filter.v.price.gte"]');
  if (minPriceInput && urlParams.has('filter.v.price.gte')) {
    const minPrice = urlParams.get('filter.v.price.gte');
    if (minPrice && minPrice.trim() !== '' && minPrice.trim() !== '0') {
      // セント単位から円単位に変換（100で割る）
      const priceInYen = Math.floor(parseInt(minPrice) / 100);
      console.log(`Restoring min price: ${minPrice} cents -> ${priceInYen} yen`);
      minPriceInput.value = priceInYen;
    }
  }
  
  // 最大価格フィールドの復元
  const maxPriceInput = form.querySelector('input[name="filter.v.price.lte"]');
  if (maxPriceInput && urlParams.has('filter.v.price.lte')) {
    const maxPrice = urlParams.get('filter.v.price.lte');
    if (maxPrice && maxPrice.trim() !== '' && maxPrice.trim() !== '0') {
      // セント単位から円単位に変換（100で割る）
      const priceInYen = Math.floor(parseInt(maxPrice) / 100);
      console.log(`Restoring max price: ${maxPrice} cents -> ${priceInYen} yen`);
      maxPriceInput.value = priceInYen;
    }
  }
}

// Remove Allリンクに直接イベントリスナーを追加（静的なもののみ）
document.addEventListener('DOMContentLoaded', function() {
  // フィルター状態を復元
  restoreFilterState();
  
  // ソートとアイテム数表示の同期を初期化
  syncFilterLabels();
  
  // ページ離脱と復帰の検知
  setupPageLeaveAndReturnHandlers();
  
  // 静的なRemove Allリンクにイベントリスナーを追加
  const removeAllLinks = document.querySelectorAll('a.active-facets__button-remove, a.mobile-facets__clear');
  removeAllLinks.forEach(link => {
    // 静的なリンクであることを識別する属性を追加
    link.setAttribute('data-static-remove-all', 'true');
    link.addEventListener('click', function(event) {
      event.preventDefault();
      console.log('Remove All link clicked directly (static)');
      removeAllFilters();
    });
  });
  
  // 動的に追加されるRemove Allリンクにも対応
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // 新しく追加されたRemove Allリンクをチェック
            const newRemoveAllLinks = node.querySelectorAll ? 
              node.querySelectorAll('a.active-facets__button-remove, a.mobile-facets__clear') : [];
            
            newRemoveAllLinks.forEach(link => {
              // 静的なリンクでない場合のみイベントリスナーを追加
              if (!link.hasAttribute('data-static-remove-all')) {
                link.addEventListener('click', function(event) {
                  event.preventDefault();
                  console.log('Remove All link clicked (dynamic)');
                  removeAllFilters();
                });
              }
            });
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

  // Apply All Filters関数 - キーワード検索時は標準検索ページへ遷移、それ以外はAjaxフィルタリング
function applyAllFilters() {
  console.log('applyAllFilters() が呼び出されました');
  
  // 一時保存されたカテゴリー状態を復元（もしあれば）
  const tempCategoryState = sessionStorage.getItem('tempCategoryState');
  if (tempCategoryState) {
    try {
      const categoryState = JSON.parse(tempCategoryState);
      console.log('Restoring temporary category state before applyAllFilters:', categoryState);
      
      // カテゴリー状態を復元
      const category1Select = document.getElementById('category-1');
      const category2Select = document.getElementById('category-2');
      
      if (category1Select && categoryState.category1) {
        category1Select.value = categoryState.category1;
      }
      if (category2Select && categoryState.category2) {
        category2Select.value = categoryState.category2;
      }
      
      // 一時保存された状態をクリア
      sessionStorage.removeItem('tempCategoryState');
      
      // DOM要素の値更新後に少し遅延させてから処理を続行
      setTimeout(() => {
        processApplyAllFilters();
      }, 100);
      return; // 早期リターンで処理を分離
    } catch (error) {
      console.error('Error restoring temporary category state before applyAllFilters:', error);
    }
  }

  // 一時保存された状態がない場合は即座に処理
  processApplyAllFilters();
}

// Apply All Filtersの処理を分離した関数
function processApplyAllFilters() {
  
  // 表示件数変更検出のため、保存前に前回の値を取得
  let previousLimitValue = null;
  const savedStateBeforeSave = sessionStorage.getItem('filterState');
  if (savedStateBeforeSave) {
    try {
      const filterState = JSON.parse(savedStateBeforeSave);
      if (filterState.itemsPerPage && filterState.itemsPerPage.trim() !== '') {
        previousLimitValue = filterState.itemsPerPage;
      }
    } catch (error) {
      console.error('Error parsing filterState for previous limit:', error);
    }
  }
  
  // フィルター状態を保存（キーワード以外）
  FacetFiltersForm.saveFilterState();
  
  const url = new URL(window.location);
  
  // キーワード検索の処理
  const keywordInput = document.getElementById('Filter-Keyword-Search');
  let keywordValue = keywordInput ? keywordInput.value.trim() : '';
  
  // キーワード検索欄が空の場合、URLのqパラメータを取得
  if (!keywordValue) {
    const urlQParam = url.searchParams.get('q');
    if (urlQParam && urlQParam.trim() !== '') {
      keywordValue = urlQParam.trim();
      console.log('キーワード検索欄が空のため、URLのqパラメータを使用:', keywordValue);
    }
  }
  
  console.log('keywordInput要素:', keywordInput);
  console.log('keywordValue:', keywordValue);
  
  // 既存のqパラメータを削除
  url.searchParams.delete('q');
  
  // キーワード検索がある場合はSearchページへ遷移
  if (keywordValue) {
    console.log('キーワード検索があるため、Searchページへ遷移します:', keywordValue);
    
    // SearchページのURLを構築
    const searchUrl = new URL('/search', window.location.origin);
    searchUrl.searchParams.set('q', keywordValue);
    
    // 他のフィルター設定を保持
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const formData = new FormData(mobileForm);
      const formDataMap = new Map();
      
      // 同じキーの値を配列として収集（qパラメータとradioボタンは除外）
      formData.forEach((value, key) => {
        if (value && value.trim() !== '' && key !== 'q' && 
            key !== 'filter.v.availability' && 
            key !== 'filter.p.m.scapp.salesType' && 
            key !== 'filter.p.m.scapp.wrappingNGFlag') {
          if (!formDataMap.has(key)) {
            formDataMap.set(key, []);
          }
          formDataMap.get(key).push(value);
        }
      });
      
      // URLパラメータに設定（複数値の場合はappendを使用）
      // カテゴリー系キーは除外（後段の優先ロジックで1組のみ付与）
      formDataMap.forEach((values, key) => {
        if (key === 'filter.p.m.scapp.categoryCodeList' || key === 'filter.p.m.scapp.categoryNameList') {
          return;
        }
        if (values.length === 1) {
          searchUrl.searchParams.set(key, values[0]);
        } else {
          // 複数値の場合は、既存のパラメータを削除してから追加
          searchUrl.searchParams.delete(key);
          values.forEach(value => {
            searchUrl.searchParams.append(key, value);
          });
        }
      });
    }
    
    // Category2を優先するロジック（mobileFormの有無に関係なく実行）
    const category1Select = document.getElementById('category-1');
    const category2Select = document.getElementById('category-2');
    const category1Value = category1Select?.value;
    const category2Value = category2Select?.value;
    
    // Category2が空の値や「All」の場合はURLパラメータに追加しない
    if (category2Value && category2Value !== '' && category2Value !== 'All') {
      searchUrl.searchParams.append('filter.p.m.scapp.categoryCodeList', category2Value);
      console.log('Using Category2 only (priority) in search redirect:', category2Value);
    } else if (category1Value && category1Value !== '' && category1Value !== 'All') {
      searchUrl.searchParams.append('filter.p.m.scapp.categoryCodeList', category1Value);
      console.log('Using Category1 only (fallback) in search redirect:', category1Value);
    }
    
    // Radioボタンの値を明示的に取得してURLパラメータに追加（mobileFormの有無に関係なく実行）
    // Availability filter
    const availabilityRadio = document.querySelector('input[name="filter.v.availability"]:checked');
    if (availabilityRadio && availabilityRadio.value && availabilityRadio.value.trim() !== '') {
      searchUrl.searchParams.set('filter.v.availability', availabilityRadio.value);
      console.log('Availability added to search URL:', availabilityRadio.value);
    } else {
      searchUrl.searchParams.delete('filter.v.availability');
    }
    
    // Price Type filter
    const priceTypeRadio = document.querySelector('input[name="filter.p.m.scapp.salesType"]:checked');
    if (priceTypeRadio && priceTypeRadio.value && priceTypeRadio.value.trim() !== '') {
      searchUrl.searchParams.set('filter.p.m.scapp.salesType', priceTypeRadio.value);
      console.log('Price Type added to search URL:', priceTypeRadio.value);
    } else {
      searchUrl.searchParams.delete('filter.p.m.scapp.salesType');
    }
    
    // Gift Wrapping filter
    const giftWrappingRadio = document.querySelector('input[name="filter.p.m.scapp.wrappingNGFlag"]:checked');
    if (giftWrappingRadio && giftWrappingRadio.value && giftWrappingRadio.value.trim() !== '') {
      searchUrl.searchParams.set('filter.p.m.scapp.wrappingNGFlag', giftWrappingRadio.value);
      console.log('Gift Wrapping added to search URL:', giftWrappingRadio.value);
    } else {
      searchUrl.searchParams.delete('filter.p.m.scapp.wrappingNGFlag');
    }
    
    // Searchページへ遷移
    console.log('Redirecting to search page with filters:', searchUrl.toString());
    window.location.href = searchUrl.toString();
    return;
  }
  
  // フィルター適用時はページネーションをリセット
  url.searchParams.delete('page');

  // Sort ByとItems per Pageの値を先に取得（mobileFormの有無に関係なく）
  // mobileFormが見つからない場合でも、直接要素を取得できるようにする
  // 複数の方法で要素を取得を試行（SP時の確実な取得のため）
  let sortByElement = document.getElementById('SortBy-mobile');
  if (!sortByElement) {
    sortByElement = document.querySelector('#SortBy-mobile');
  }
  if (!sortByElement) {
    sortByElement = document.querySelector('select[name="sort_by"][id="SortBy-mobile"]');
  }
  
  let limitElement = document.getElementById('product-limit-mobile');
  if (!limitElement) {
    limitElement = document.querySelector('#product-limit-mobile');
  }
  if (!limitElement) {
    limitElement = document.querySelector('select[name="limit"][id="product-limit-mobile"]');
  }
  // PC用の要素も試行（SP/PCの切り替え時に対応）
  if (!limitElement) {
    limitElement = document.getElementById('product-limit');
  }
  if (!limitElement) {
    limitElement = document.querySelector('#product-limit');
  }
  
  const sortByValue = sortByElement?.value || '';
  // limitValueの取得：要素から取得、なければセッションストレージから、URLパラメータから、それもなければデフォルト値（60）
  // 初回のApply時でも必ずlimitパラメータが設定されるようにする
  let limitValue = limitElement?.value || '';
  
  console.log('Limit element detection:', {
    limitElement: !!limitElement,
    limitElementValue: limitElement?.value,
    limitElementId: limitElement?.id,
    limitElementName: limitElement?.name
  });
  
  if (!limitValue || limitValue.trim() === '') {
    // セッションストレージから取得を試行
    const savedState = sessionStorage.getItem('filterState');
    let sessionStorageLimit = '';
    if (savedState) {
      try {
        const filterState = JSON.parse(savedState);
        if (filterState.itemsPerPage && filterState.itemsPerPage.trim() !== '') {
          limitValue = filterState.itemsPerPage;
          sessionStorageLimit = filterState.itemsPerPage;
          console.log('Limit value retrieved from sessionStorage:', limitValue);
        }
      } catch (error) {
        console.error('Error parsing filterState from sessionStorage:', error);
      }
    }
    
    // セッションストレージから取得できなかった場合、URLパラメータから取得
    if (!limitValue || limitValue.trim() === '') {
      const urlLimit = url.searchParams.get('limit');
      if (urlLimit) {
        limitValue = urlLimit;
        console.log('Limit value retrieved from URL:', limitValue);
      } else {
        // デフォルト値として60を設定（初回のApply時でも必ずlimitパラメータが設定されるように）
        limitValue = '60';
        console.log('Limit value set to default (60)');
      }
    }
  } else {
    console.log('Limit value retrieved from element:', limitValue);
  }
  
  console.log('Form values detected (before mobileForm check):', {
    sortByElement: !!sortByElement,
    limitElement: !!limitElement,
    sortByElementValue: sortByElement?.value,
    limitElementValue: limitElement?.value,
    sortByValue: sortByValue,
    limitValue: limitValue,
    urlLimit: url.searchParams.get('limit')
  });
  
  // limitValueが存在し、かつ現在のURLのlimitパラメータと異なる場合のみページリロード
  // 表示件数が変更された場合は、初回Apply時でもページリロードを実行する（cart.attributesの更新とページネーションのリセットのため）
  // limitValueは必ず設定されている（デフォルト値60が設定されているため）
  const currentLimit = url.searchParams.get('limit');
  const isFirstApply = currentLimit === null || currentLimit === undefined;
  
  // 表示件数が変更されたかどうかを判定
  // 1. URLパラメータと異なる場合
  // 2. セッションストレージの前回値と異なる場合（SP時の表示件数変更検出のため）
  // previousLimitValueは、saveFilterState()の前に取得した値を使用
  const isLimitChangedFromURL = currentLimit !== null && currentLimit !== undefined && limitValue !== currentLimit;
  const isLimitChangedFromStorage = previousLimitValue !== null && previousLimitValue !== '' && limitValue !== previousLimitValue;
  const isLimitChanged = isLimitChangedFromURL || isLimitChangedFromStorage;
  
  // デバッグログを追加
  console.log('Limit change detection:', {
    limitValue: limitValue,
    limitValueType: typeof limitValue,
    currentLimit: currentLimit,
    currentLimitType: typeof currentLimit,
    previousLimitValue: previousLimitValue,
    areEqual: limitValue === currentLimit,
    areNotEqual: limitValue !== currentLimit,
    isFirstApply: isFirstApply,
    isLimitChangedFromURL: isLimitChangedFromURL,
    isLimitChangedFromStorage: isLimitChangedFromStorage,
    isLimitChanged: isLimitChanged,
    limitElementFound: !!limitElement,
    limitElementValue: limitElement?.value
  });
  
  // 表示件数が実際に変更された場合、即座にページリロード（初回Apply時でも）
  // cart.attributesの更新とページネーションのリセットのため、ページリロードが必要
  if (isLimitChanged) {
    url.searchParams.set('limit', limitValue);
    console.log('Items per Page changed, updating cart and reloading:', limitValue, 'from', currentLimit);
    
    // 表示件数変更時はcart.attributesも更新してページリロード
    // fetch APIを使用（jQueryの依存を避けるため）
    // ShopifyのカートAPI: /cart/update.js にPOSTリクエストを送信
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          pagination: limitValue
        }
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log('Cart attributes updated for pagination:', limitValue);
      // 表示件数変更時はページリロード
      console.log('Redirecting to:', url.toString());
      window.location.href = url.toString();
    })
    .catch(error => {
      console.error('カート属性更新エラー:', error);
      // エラーが発生してもURLパラメータは設定されているので、ページリロードを試みる
      console.log('Cart update failed, but redirecting anyway:', url.toString());
      window.location.href = url.toString();
    });
    return; // 表示件数変更時はここで処理を終了
  } else {
    // 表示件数が変更されていない場合、URLパラメータに設定して続行（Ajax通信でフィルタリングを実行）
    // limitValueは必ず設定されている（デフォルト値60が設定されているため）
    url.searchParams.set('limit', limitValue);
    if (isFirstApply) {
      console.log('First Apply: Items per Page set to URL (no change, will process filters via Ajax):', limitValue);
    } else {
      console.log('Items per Page added to URL (no change):', limitValue, 'currentLimit was:', currentLimit);
    }
  }

  // 既存のフィルターパラメータをクリア（Sort By、Items per Page、qは除外）
  const filterKeys = Array.from(url.searchParams.keys()).filter(key => 
    key.startsWith('filter.') || 
    key.startsWith('variant_option') || 
    key.startsWith('options[')
  );
  filterKeys.forEach(key => url.searchParams.delete(key));
  
  // キャラクターのチェックボックスを直接取得（フォームの有無に関係なく確実に取得）
  const characterCheckboxes = document.querySelectorAll('input[name="filter.p.m.scapp.characterCode"]:checked');
  console.log('Character checkboxes found:', characterCheckboxes.length, Array.from(characterCheckboxes).map(cb => cb.value));
  
  // 既存のキャラクターパラメータを削除
  url.searchParams.delete('filter.p.m.scapp.characterCode');
  // キャラクターのチェックボックスをURLパラメータに追加
  characterCheckboxes.forEach(checkbox => {
    if (checkbox.value && checkbox.value.trim() !== '') {
      url.searchParams.append('filter.p.m.scapp.characterCode', checkbox.value);
    }
  });
  
  // 価格フィールドを直接取得（フォームの有無に関係なく確実に取得）
  const minPriceInput = document.querySelector('input[name="filter.v.price.gte"]');
  if (minPriceInput && minPriceInput.value && minPriceInput.value.trim() !== '') {
    url.searchParams.set('filter.v.price.gte', minPriceInput.value);
    console.log('Min price added to URL:', minPriceInput.value);
  } else {
    url.searchParams.delete('filter.v.price.gte');
  }
  
  const maxPriceInput = document.querySelector('input[name="filter.v.price.lte"]');
  if (maxPriceInput && maxPriceInput.value && maxPriceInput.value.trim() !== '') {
    url.searchParams.set('filter.v.price.lte', maxPriceInput.value);
    console.log('Max price added to URL:', maxPriceInput.value);
  } else {
    url.searchParams.delete('filter.v.price.lte');
  }
  
  // フィルターフォームから他のデータを収集（キャラクターと価格は既に処理済み）
  const mobileForm = document.getElementById('FacetFiltersFormMobile');
  console.log('Mobile form found:', !!mobileForm);
  
  if (mobileForm) {
    const formData = new FormData(mobileForm);
    const formDataMap = new Map();
    
    // 同じキーの値を配列として収集（radioボタン、キャラクター、価格は除外）
    formData.forEach((value, key) => {
      if (value && value.trim() !== '' && 
          key !== 'filter.v.availability' && 
          key !== 'filter.p.m.scapp.salesType' && 
          key !== 'filter.p.m.scapp.wrappingNGFlag' &&
          key !== 'filter.p.m.scapp.characterCode' && // キャラクターは既に処理済み
          key !== 'filter.v.price.gte' && // 価格は既に処理済み
          key !== 'filter.v.price.lte') { // 価格は既に処理済み
        if (!formDataMap.has(key)) {
          formDataMap.set(key, []);
        }
        formDataMap.get(key).push(value);
      }
    });
    
    console.log('Form data collected (excluding character and price):', Array.from(formDataMap.entries()));
    
    // URLパラメータに設定（複数値の場合はappendを使用）
    // カテゴリー系キーは除外（後段の優先ロジックで1組のみ付与）
    formDataMap.forEach((values, key) => {
      if (key === 'filter.p.m.scapp.categoryCodeList' || key === 'filter.p.m.scapp.categoryNameList') {
        return;
      }
      if (values.length === 1) {
        url.searchParams.set(key, values[0]);
      } else {
        // 複数値の場合は、既存のパラメータを削除してから追加
        url.searchParams.delete(key);
        values.forEach(value => {
          url.searchParams.append(key, value);
        });
      }
    });
  } else {
    console.warn('Mobile form not found, but character and price already collected');
  }
  
  // Category2を優先するロジック（mobileFormの有無に関係なく実行）
  // SPモードでも確実に要素を取得するため、複数の方法で試行
  let category1Select = document.getElementById('category-1');
  let category2Select = document.getElementById('category-2');
  
  // 要素が見つからない場合、querySelectorでも試行
  if (!category1Select) {
    category1Select = document.querySelector('#category-1');
  }
  if (!category2Select) {
    category2Select = document.querySelector('#category-2');
  }
  
  // まだ見つからない場合、name属性で検索
  if (!category1Select) {
    category1Select = document.querySelector('select[name="filter.p.m.scapp.categoryCodeList"][id="category-1"]');
  }
  if (!category2Select) {
    category2Select = document.querySelector('select[name="filter.p.m.scapp.categoryCodeList"][id="category-2"]');
  }
  
  const category1Value = category1Select?.value || '';
  const category2Value = category2Select?.value || '';
  
  // 既存のカテゴリーパラメータを削除（コロン形式も含む）
  const categoryKeys = Array.from(url.searchParams.keys()).filter(key => 
    key.startsWith('filter.p.m.scapp.categoryCodeList') || 
    key.startsWith('filter.p.m.scapp.categoryNameList')
  );
  categoryKeys.forEach(key => url.searchParams.delete(key));
  
  // Category2が選択されている場合はCategory2のみを使用、そうでなければCategory1を使用
  console.log('Category values in applyAllFilters:', {
    category1: category1Value,
    category2: category2Value,
    category1Element: category1Select,
    category2Element: category2Select,
    category1Found: !!category1Select,
    category2Found: !!category2Select,
    category1Options: category1Select ? Array.from(category1Select.options).map(o => ({value: o.value, text: o.text})) : [],
    category2Options: category2Select ? Array.from(category2Select.options).map(o => ({value: o.value, text: o.text})) : []
  });
  
  // Category2が空の値や「All」の場合はURLパラメータに追加しない
  if (category2Value && category2Value !== '' && category2Value !== 'All') {
    // メタフィールドフィルタリング用のパラメータ（等号形式）
    url.searchParams.append('filter.p.m.scapp.categoryCodeList', category2Value);
    console.log('Using Category2 only (priority) in applyAllFilters with equals format:', category2Value);
  } else if (category1Value && category1Value !== '' && category1Value !== 'All') {
    // メタフィールドフィルタリング用のパラメータ（等号形式）
    url.searchParams.append('filter.p.m.scapp.categoryCodeList', category1Value);
    console.log('Using Category1 only (fallback) in applyAllFilters with equals format:', category1Value);
  } else {
    console.log('No valid category values found - no category parameters will be added');
  }
  
  console.log('Category priority logic applied in applyAllFilters:', {
    category1: category1Value,
    category2: category2Value,
    selected: category2Value && category2Value !== '' && category2Value !== 'All' ? 'Category2' : 'Category1'
  });

  // Radioボタンの値を明示的に取得してURLパラメータに追加（mobileFormの有無に関係なく実行）
  // Availability filter
  const availabilityRadio = document.querySelector('input[name="filter.v.availability"]:checked');
  if (availabilityRadio && availabilityRadio.value && availabilityRadio.value.trim() !== '') {
    url.searchParams.set('filter.v.availability', availabilityRadio.value);
    console.log('Availability added to URL:', availabilityRadio.value);
  } else {
    // 空の値が選択されている場合はパラメータを削除
    url.searchParams.delete('filter.v.availability');
    console.log('Availability removed from URL (No Preference selected)');
  }
  
  // Price Type filter
  const priceTypeRadio = document.querySelector('input[name="filter.p.m.scapp.salesType"]:checked');
  if (priceTypeRadio && priceTypeRadio.value && priceTypeRadio.value.trim() !== '') {
    url.searchParams.set('filter.p.m.scapp.salesType', priceTypeRadio.value);
    console.log('Price Type added to URL:', priceTypeRadio.value);
  } else {
    url.searchParams.delete('filter.p.m.scapp.salesType');
    console.log('Price Type removed from URL (View All selected)');
  }
  
  // Gift Wrapping filter
  const giftWrappingRadio = document.querySelector('input[name="filter.p.m.scapp.wrappingNGFlag"]:checked');
  if (giftWrappingRadio && giftWrappingRadio.value && giftWrappingRadio.value.trim() !== '') {
    url.searchParams.set('filter.p.m.scapp.wrappingNGFlag', giftWrappingRadio.value);
    console.log('Gift Wrapping added to URL:', giftWrappingRadio.value);
  } else {
    url.searchParams.delete('filter.p.m.scapp.wrappingNGFlag');
    console.log('Gift Wrapping removed from URL (No Preference selected)');
  }
  
  // Sort Byの値をURLパラメータに追加（limitValueは既に処理済み）
  if (sortByValue) {
    url.searchParams.set('sort_by', sortByValue);
    console.log('Sort By added to URL:', sortByValue);
  }
  
  // URLパラメータの最終確認
  console.log('Final URL before Ajax:', url.toString());
  console.log('URL search params:', url.searchParams.toString());
  
  // Ajax処理でフィルタリングを実行（表示件数変更がない場合のみ）
  const searchParams = url.searchParams.toString();
  console.log('Final search params for Ajax:', searchParams);
  
  // URLを更新してからAjax処理を実行
  // 注意: renderPage()内でもupdateURLHash()が呼ばれるため、ここではpushStateしない
  // 代わりに、renderPage()にupdateURLHash=falseを渡して、ここで一度だけ更新する
  // 現在のURLと異なる場合のみpushStateを実行（重複を防ぐ）
  // URLパラメータの順序を無視して比較
  const newUrl = url.toString();
  if (!FacetFiltersForm.isSameUrl(window.location.href, newUrl)) {
    window.history.pushState({ searchParams }, '', newUrl);
    console.log('processApplyAllFilters: URL updated to:', newUrl);
  } else {
    console.log('processApplyAllFilters: URL unchanged, skipping pushState:', newUrl);
  }
  
  // renderPage()内のupdateURLHash()をスキップして、重複した履歴エントリを防ぐ
  FacetFiltersForm.renderPage(searchParams, null, false);
  
  // フィルター適用後もスクロール状態をリセット（SP時の縦スクロール問題対策）
  setTimeout(() => {
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    document.querySelectorAll('.mobile-facets__wrapper details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
  }, 100);
}


// Remove All Filters関数 - すべてのフィルターをクリアしてページリロード
function removeAllFilters() {
  console.log('removeAllFilters() called');
  
  // フィルター状態をクリア（Sort ByとItems per Pageはデフォルト値に設定）
  const defaultFilterState = {
    sortBy: 'created-descending',
    itemsPerPage: '60'
  };
  sessionStorage.setItem('filterState', JSON.stringify(defaultFilterState));
  console.log('Filter state cleared, Sort By and Items per Page set to default values');
  
  const url = new URL(window.location);
  
  // Searchページかどうかを判定
  const isSearchPage = window.location.pathname.includes('/search');
  
  // フィルター関連のパラメータをすべて削除（Sort ByとItems per Pageは除外）
  const filterKeys = Array.from(url.searchParams.keys()).filter(key => {
    // Searchページの場合は検索キーワード（q）を保持
    if (isSearchPage && key === 'q') {
      return false; // qパラメータは削除しない
    }
    return key.startsWith('filter.') || 
           key.startsWith('variant_option') || 
           key.startsWith('options[') ||
           key === 'page' ||
           (!isSearchPage && key === 'q'); // Collectionページの場合はqも削除
  });
  
  console.log('Removing filter keys:', filterKeys);
  filterKeys.forEach(key => url.searchParams.delete(key));
  
  // Sort ByとItems per Pageをデフォルト値に設定
  url.searchParams.set('sort_by', 'created-descending'); // デフォルト値
  url.searchParams.set('limit', '60'); // デフォルト値
  
  console.log('Sort By and Items per Page reset to default values');
  console.log('Final URL for removeAllFilters:', url.toString());
  console.log('URL search params:', url.searchParams.toString());
  
  // カスタムイベントを発火（パンくず更新用）
  document.dispatchEvent(new CustomEvent('filters:cleared', {
    detail: { removedKeys: filterKeys }
  }));
  
  // Searchページの場合はページリロード、Collectionページの場合はAjax処理
  if (isSearchPage) {
    // Searchページの場合はページリロードで確実にフィルターをクリア（検索キーワードは保持）
    window.location.href = url.toString();
  } else {
    // Collectionページの場合はAjax処理でフィルターをクリア
    const searchParams = url.searchParams.toString();
    FacetFiltersForm.renderPage(searchParams);
  }
  
  // フィルター画面を閉じる処理（アニメーション付き）
  const closeFilterWithAnimation = () => {
    const filterDetails = document.querySelectorAll('.mobile-facets__wrapper details');
    
    filterDetails.forEach(details => {
      // menu-openingクラスを削除してアニメーション開始
      details.classList.remove('menu-opening');
      
      // アニメーション完了後に完全に閉じる
      const closeAnimation = () => {
        let animationStart;
        
        const handleAnimation = (time) => {
          if (animationStart === undefined) {
            animationStart = time;
          }
          
          const elapsedTime = time - animationStart;
          
          if (elapsedTime < 400) { // 400msのアニメーション時間
            window.requestAnimationFrame(handleAnimation);
          } else {
            // アニメーション完了後に完全に閉じる
            details.removeAttribute('open');
            document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
          }
        };
        
        window.requestAnimationFrame(handleAnimation);
      };
      
      closeAnimation();
    });
  };
  
  // アニメーション処理を開始
  closeFilterWithAnimation();
}


// カテゴリー連動機能を再設定
function setupCategoryEventListeners() {
  const firstSelect = document.getElementById('category-1');
  const secondSelect = document.getElementById('category-2');
  
  if (!firstSelect || !secondSelect) {
    return; // 要素が存在しない場合は何もしない
  }

  // cloneNode(true)はJSで設定した現在値(.value)を引き継がないため
  // （HTMLのselected属性ベースの「All」に戻ってしまう）、複製前に現在の選択値を保持しておく
  const preservedCategory1Value = firstSelect.value;
  const preservedCategory2Value = secondSelect.value;

  // 既存のイベントリスナーを削除（重複を防ぐため）
  const newFirstSelect = firstSelect.cloneNode(true);
  firstSelect.parentNode.replaceChild(newFirstSelect, firstSelect);

  const newSecondSelect = secondSelect.cloneNode(true);
  secondSelect.parentNode.replaceChild(newSecondSelect, secondSelect);

  // 元の選択肢を保持
  const secondOptions = Array.from(newSecondSelect.querySelectorAll('option'));
  
  // 1つ目のセレクトボックスの変更イベントリスナーを再設定
  newFirstSelect.addEventListener('change', function() {
    const selectedValue = newFirstSelect.options[newFirstSelect.selectedIndex].getAttribute('data-second-cat');
    const category1Value = newFirstSelect.options[newFirstSelect.selectedIndex].value;
    
    // 2つ目のセレクトボックスをリセット
    newSecondSelect.innerHTML = '';
    
    // Category1が"All"（空文字列）の場合はCategory2を空のままにする
    if (!category1Value || category1Value === '' || !selectedValue) {
      console.log('setupCategoryEventListeners: Category1 is "All", clearing Category2');
      newSecondSelect.value = '';
      return;
    }
    
    // 選択されたカテゴリに応じて対応する選択肢を追加
    if (selectedValue) {
      secondOptions.forEach(option => {
        if (option.classList.contains(selectedValue)) {
          newSecondSelect.appendChild(option.cloneNode(true));
        }
      });
    }
  });
  
  // 保持しておいた選択値を復元してから初期化を実行（「All」へのリセットを防ぐ）
  newFirstSelect.value = preservedCategory1Value;
  newFirstSelect.dispatchEvent(new Event('change'));
  newSecondSelect.value = preservedCategory2Value;
}

// ソートとアイテム数表示の同期機能
function syncFilterLabels() {
  // Sort By の同期
  const sortSelect = document.getElementById('SortBy-mobile');
  const sortLabel = document.getElementById('sort-current-select');
  
  if (sortSelect && sortLabel) {
    // 初期値の設定
    updateSortLabel();
    
    // 変更時のイベントリスナー
    sortSelect.addEventListener('change', updateSortLabel);
  }
  
  // Items per Page の同期
  const limitSelect = document.getElementById('product-limit-mobile');
  const limitLabel = document.getElementById('limit-current-select');
  
  if (limitSelect && limitLabel) {
    // 初期値の設定
    updateLimitLabel();
    
    // 変更時のイベントリスナー
    limitSelect.addEventListener('change', updateLimitLabel);
  }
}

// Sort By ラベルの更新
function updateSortLabel() {
  const sortSelect = document.getElementById('SortBy-mobile');
  const sortLabel = document.getElementById('sort-current-select');
  
  if (sortSelect && sortLabel) {
    const selectedOption = sortSelect.options[sortSelect.selectedIndex];
    const selectedText = selectedOption.textContent;
    sortLabel.textContent = selectedText;
    console.log('Sort By label updated to:', selectedText);
  }
}

// Items per Page ラベルの更新
function updateLimitLabel() {
  const limitSelect = document.getElementById('product-limit-mobile');
  const limitLabel = document.getElementById('limit-current-select');
  
  if (limitSelect && limitLabel) {
    const selectedOption = limitSelect.options[limitSelect.selectedIndex];
    const selectedText = selectedOption ? selectedOption.textContent : limitSelect.value;
    limitLabel.textContent = selectedText;
    console.log('Items per Page label updated to:', selectedText);
  } else {
    console.log('Items per Page elements not found:', {
      limitSelect: !!limitSelect,
      limitLabel: !!limitLabel
    });
  }
}

// Price Type ラベルの更新
function updatePriceTypeLabel() {
  const priceTypeRadios = document.querySelectorAll('input[name="filter.p.m.scapp.salesType"]');
  const priceTypeLabel = document.querySelector('#Pricetype .mobile-facets__summary-currentselect');
  
  if (priceTypeRadios && priceTypeLabel) {
    let selectedText = 'View All';
    for (const radio of priceTypeRadios) {
      if (radio.checked) {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        if (label) {
          selectedText = label.textContent.trim();
        }
        break;
      }
    }
    priceTypeLabel.textContent = selectedText;
    console.log('Price Type label updated to:', selectedText);
  }
}

// Availability ラベルの更新
function updateAvailabilityLabel() {
  const availabilityRadios = document.querySelectorAll('input[name="filter.v.availability"]');
  const availabilityLabel = document.querySelector('#Stock .mobile-facets__summary-currentselect');
  
  if (availabilityRadios && availabilityLabel) {
    let selectedText = 'No Preference';
    for (const radio of availabilityRadios) {
      if (radio.checked) {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        if (label) {
          selectedText = label.textContent.trim();
        }
        break;
      }
    }
    availabilityLabel.textContent = selectedText;
    console.log('Availability label updated to:', selectedText);
  }
}

// Gift Wrapping ラベルの更新
function updateGiftWrappingLabel() {
  const giftWrappingRadios = document.querySelectorAll('input[name="filter.p.m.scapp.wrappingNGFlag"]');
  const giftWrappingLabel = document.querySelector('#Wrapping .mobile-facets__summary-currentselect');
  
  if (giftWrappingRadios && giftWrappingLabel) {
    let selectedText = 'No Preference';
    for (const radio of giftWrappingRadios) {
      if (radio.checked) {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        if (label) {
          selectedText = label.textContent.trim();
        }
        break;
      }
    }
    giftWrappingLabel.textContent = selectedText;
    console.log('Gift Wrapping label updated to:', selectedText);
  }
}



